/**
 * BudgetLineItemService
 * Service for BudgetLineItem entity operations
 * Route: api/budget-line-items
 * Controller: BudgetLineItemController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * BudgetLineItemService
 * Handles budget line item CRUD operations
 * Maps to /api/budget-line-items endpoint
 */
export class BudgetLineItemService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? BudgetLineItemService.DEFAULT_SERVICE_PATH,
            basePath: BudgetLineItemService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
BudgetLineItemService.DEFAULT_SERVICE_PATH = 'projects';
BudgetLineItemService.BASE_PATH = 'api/budget-line-items';
//# sourceMappingURL=BudgetLineItemService.js.map